const PlayerActionType = {
  GET_PLAYER_DATA: 'GET_PLAYER_DATA',
  SAVE_PLAYER_DATA: 'SAVE_PLAYER_DATA',
  RESET_PLAYER_DATA: 'RESET_PLAYER_DATA',

  EDIT_PLAYER: 'EDIT_PLAYER',
  EDIT_PLAYER_SUCCESS: 'EDIT_PLAYER_SUCCESS',
  EDIT_PLAYER_FAILURE: 'EDIT_PLAYER_FAILURE',

  CHANGE_PLAYER_LOADING_STATE: 'CHANGE_PLAYER_LOADING_STATE',
  CHANGE_PLAYER_MODAL_LOADING_STATE: 'CHANGE_PLAYER_MODAL_LOADING_STATE',
  CHANGE_PLAYER_REPORT_LOADING_STATE: 'CHANGE_PLAYER_REPORT_LOADING_STATE',

  GET_PLAYER_NOTES: 'GET_PLAYER_NOTES',
  SAVE_PLAYER_NOTES: 'SAVE_PLAYER_NOTES',
  RESET_PLAYER_NOTES: 'RESET_PLAYER_NOTES',

  CHANGE_PLAYER_NOTES_LOADING_STATE: 'CHANGE_PLAYER_NOTES_LOADING_STATE',

  GET_PLAYER_NOTE_TYPES: 'GET_PLAYER_NOTE_TYPES',
  SAVE_PLAYER_NOTE_TYPES: 'SAVE_PLAYER_NOTE_TYPES',
  RESET_PLAYER_NOTE_TYPES: 'RESET_PLAYER_NOTE_TYPES',

  EXPORT_PLAYER_NOTES: 'EXPORT_PLAYER_NOTES',

  ADD_PLAYER_NOTE: 'ADD_PLAYER_NOTE',

  CHANGE_PLAYER_MODAL_VISIBILITY: 'CHANGE_PLAYER_MODAL_VISIBILITY',
  CHANGE_PLAYER_ENDED_STATUS: 'CHANGE_PLAYER_ENDED_STATUS',

  GET_PLAYER_MASS_MESSAGES: 'GET_PLAYER_MASS_MESSAGES',
  RESET_PLAYER_MASS_MESSAGES: 'RESET_PLAYER_MASS_MESSAGES',
  GET_PLAYER_MESSAGE: 'GET_PLAYER_MESSAGE',
  SAVE_PLAYER_MESSAGES: 'SAVE_PLAYER_MESSAGES',
  SAVE_PLAYER_MESSAGE: 'SAVE_PLAYER_MESSAGE',
  RESET_PLAYER_MESSAGE: 'RESET_PLAYER_MESSAGE',
  SAVE_PLAYER_MESSAGES_TOTAL: 'SAVE_PLAYER_MESSAGES_TOTAL',

  GET_PLAYER_CONTROLS: 'GET_PLAYER_CONTROLS',
  SAVE_PLAYER_CONTROLS: 'SAVE_PLAYER_CONTROLS',
  RESET_PLAYER_CONTROLS: 'RESET_PLAYER_CONTROLS',

  EDIT_PLAYER_MARK_ATTENTION: 'EDIT_PLAYER_MARK_ATTENTION',
  UNLOCK_PLAYER: 'UNLOCK_PLAYER',
  CHANGE_PLAYER_STATUS: 'CHANGE_PLAYER_STATUS',
  CLOSE_PLAYER_ACCOUNT: 'CLOSE_PLAYER_ACCOUNT',
  ACTIVATE_DORMANT_PLAYER: 'ACTIVATE_DORMANT_PLAYER',
  DISABLE_PLAYER_LOGIN_TFA: 'DISABLE_PLAYER_LOGIN_TFA',
  BLOCK_PLAYER_ACTIVITIES: 'BLOCK_PLAYER_ACTIVITIES',
  UNBLOCK_PLAYER_ACTIVITIES: 'UNBLOCK_PLAYER_ACTIVITIES',

  GET_PLAYER_ACTIONS: 'GET_PLAYER_ACTIONS',
  SAVE_PLAYER_ACTIONS: 'SAVE_PLAYER_ACTIONS',
  RESET_PLAYER_ACTIONS: 'RESET_PLAYER_ACTIONS',
  EXPORT_PLAYER_ACTIONS: 'EXPORT_PLAYER_ACTIONS',

  CHANGE_PLAYER_DATA_UPDATED_STATUS: 'CHANGE_PLAYER_DATA_UPDATED_STATUS',

  UPDATE_PLAYER_VERIFICATION: 'UPDATE_PLAYER_VERIFICATION',
  UPDATE_PLAYER_CONTACT_INFO_VERIFICATION: 'UPDATE_PLAYER_CONTACT_INFO_VERIFICATION',

  GET_PLAYER_TIMOUT_SETTINGS: 'GET_PLAYER_TIMOUT_SETTINGS',
  SAVE_PLAYER_TIMOUT_SETTINGS: 'SAVE_PLAYER_TIMOUT_SETTINGS',
  EDIT_PLAYER_TIMOUT_SETTINGS: 'EDIT_PLAYER_TIMOUT_SETTINGS',
  GET_PLAYER_DEPOSIT_SETTINGS: 'GET_PLAYER_DEPOSIT_SETTINGS',
  SAVE_PLAYER_DEPOSIT_SETTINGS: 'SAVE_PLAYER_DEPOSIT_SETTINGS',
  EDIT_PLAYER_DEPOSIT_SETTINGS: 'EDIT_PLAYER_DEPOSIT_SETTINGS',
  GET_PLAYER_NET_DEPOSIT_SETTINGS: 'GET_PLAYER_NET_DEPOSIT_SETTINGS',
  SAVE_PLAYER_NET_DEPOSIT_SETTINGS: 'SAVE_PLAYER_NET_DEPOSIT_SETTINGS',
  EDIT_PLAYER_NET_DEPOSIT_SETTINGS: 'EDIT_PLAYER_NET_DEPOSIT_SETTINGS',
  GET_PLAYER_WITHDRAWAL_SETTINGS: 'GET_PLAYER_WITHDRAWAL_SETTINGS',
  SAVE_PLAYER_WITHDRAWAL_SETTINGS: 'SAVE_PLAYER_WITHDRAWAL_SETTINGS',
  EDIT_PLAYER_WITHDRAWAL_SETTINGS: 'EDIT_PLAYER_WITHDRAWAL_SETTINGS',
  GET_PLAYER_BET_SETTINGS: 'GET_PLAYER_BET_SETTINGS',
  SAVE_PLAYER_BET_SETTINGS: 'SAVE_PLAYER_BET_SETTINGS',
  EDIT_PLAYER_BET_SETTINGS: 'EDIT_PLAYER_BET_SETTINGS',
  GET_PLAYER_REALITY_CHECK_SETTINGS: 'GET_PLAYER_REALITY_CHECK_SETTINGS',
  SAVE_PLAYER_REALITY_CHECK_SETTINGS: 'SAVE_PLAYER_REALITY_CHECK_SETTINGS',
  EDIT_PLAYER_REALITY_CHECK_SETTINGS: 'EDIT_PLAYER_REALITY_CHECK_SETTINGS',
  RESET_PLAYER_RESPONSIBLE_GAMING_SETTINGS: 'RESET_PLAYER_RESPONSIBLE_GAMING_SETTINGS',
  GET_PLAYER_LOSS_LIMIT_SETTINGS: 'GET_PLAYER_LOSS_LIMIT_SETTINGS',
  SAVE_PLAYER_LOSS_LIMIT_SETTINGS: 'SAVE_PLAYER_LOSS_LIMIT_SETTINGS',
  EDIT_PLAYER_LOSS_LIMIT_SETTINGS: 'EDIT_PLAYER_LOSS_LIMIT_SETTINGS',
  GET_PLAYER_SINGLE_BET_SETTINGS: 'GET_PLAYER_SINGLE_BET_SETTINGS',
  SAVE_PLAYER_SINGLE_BET_SETTINGS: 'SAVE_PLAYER_SINGLE_BET_SETTINGS',
  EDIT_PLAYER_SINGLE_BET_SETTINGS: 'EDIT_PLAYER_SINGLE_BET_SETTINGS',
  GET_RESPONSIBLE_GAMING_LOGS: 'GET_RESPONSIBLE_GAMING_LOGS',
  SAVE_RESPONSIBLE_GAMING_LOGS: 'SAVE_RESPONSIBLE_GAMING_LOGS',
  RESET_RESPONSIBLE_GAMING_LOGS: 'RESET_RESPONSIBLE_GAMING_LOGS',
  GET_RESPONSIBLE_GAMING_REMINDER_LIMITS: 'GET_RESPONSIBLE_GAMING_REMINDER_LIMITS',
  SAVE_RESPONSIBLE_GAMING_REMINDER_LIMITS: 'SAVE_RESPONSIBLE_GAMING_REMINDER_LIMITS',
  RESET_RESPONSIBLE_GAMING_REMINDER_LIMITS: 'RESET_RESPONSIBLE_GAMING_REMINDER_LIMITS',
  GET_PLAYER_ACCESS_LIMIT_SETTINGS: 'GET_PLAYER_ACCESS_LIMIT_SETTINGS',
  SAVE_PLAYER_ACCESS_LIMIT_SETTINGS: 'SAVE_PLAYER_ACCESS_LIMIT_SETTINGS',
  EDIT_PLAYER_ACCESS_LIMIT_SETTINGS: 'EDIT_PLAYER_ACCESS_LIMIT_SETTINGS',
  GET_PLAYER_ACCESS_LIMIT_OVERVIEW_SETTINGS: 'GET_PLAYER_ACCESS_LIMIT_OVERVIEW_SETTINGS',
  SAVE_PLAYER_ACCESS_LIMIT_OVERVIEW_SETTINGS: 'SAVE_PLAYER_ACCESS_LIMIT_OVERVIEW_SETTINGS',
  GET_PLAYER_ACCESS_LIMIT_PENDING_SETTINGS: 'GET_PLAYER_ACCESS_LIMIT_PENDING_SETTINGS',
  SAVE_PLAYER_ACCESS_LIMIT_PENDING_SETTINGS: 'SAVE_PLAYER_ACCESS_LIMIT_PENDING_SETTINGS',
  GET_PLAYER_ACCESS_LIMIT_SETTINGS_LOG: 'GET_PLAYER_ACCESS_LIMIT_SETTINGS_LOG',
  RESET_PLAYER_ACCESS_LIMIT_SETTINGS_LOG: 'RESET_PLAYER_ACCESS_LIMIT_SETTINGS_LOG',
  SAVE_PLAYER_ACCESS_LIMIT_SETTINGS_LOG: 'SAVE_PLAYER_ACCESS_LIMIT_SETTINGS_LOG',

  GET_PLAYER_PERSONAL_INFO: 'GET_PLAYER_PERSONAL_INFO',
  SAVE_PLAYER_PERSONAL_INFO: 'SAVE_PLAYER_PERSONAL_INFO',
  RESET_PLAYER_PERSONAL_INFO: 'RESET_PLAYER_PERSONAL_INFO',

  GET_PLAYER_ACCOUNT_INFO: 'GET_PLAYER_ACCOUNT_INFO',
  SAVE_PLAYER_ACCOUNT_INFO: 'SAVE_PLAYER_ACCOUNT_INFO',
  RESET_PLAYER_ACCOUNT_INFO: 'RESET_PLAYER_ACCOUNT_INFO',

  CHANGE_PLAYER_PERSONAL_INFO_UPDATED_STATUS: 'CHANGE_PLAYER_PERSONAL_INFO_UPDATED_STATUS',
  CHANGE_PLAYER_ACCOUNT_INFO_UPDATED_STATUS: 'CHANGE_PLAYER_ACCOUNT_INFO_UPDATED_STATUS',

  CHANGE_PLAYER_ACTIONS_ENDED_STATUS: 'CHANGE_PLAYER_ACTIONS_ENDED_STATUS',

  CHANGE_PLAYER_LIMITS_LOADING: 'CHANGE_PLAYER_LIMITS_LOADING',

  GET_HAS_PLAYER_TRANSACTION: 'GET_HAS_PLAYER_TRANSACTION',
  SAVE_HAS_PLAYER_TRANSACTION: 'SAVE_HAS_PLAYER_TRANSACTION',
  RESET_HAS_PLAYER_TRANSACTION: 'RESET_HAS_PLAYER_TRANSACTION',

  CHANGE_HAS_PLAYER_TRANSACTION_LOADING_STATE: 'CHANGE_HAS_PLAYER_TRANSACTION_LOADING_STATE',

  GET_PLAYER_GAME_TIME_LIMIT_SETTINGS: 'GET_PLAYER_GAME_TIME_LIMIT_SETTINGS',
  SAVE_PLAYER_GAME_TIME_LIMIT_SETTINGS: 'SAVE_PLAYER_GAME_TIME_LIMIT_SETTINGS',
  EDIT_PLAYER_GAME_TIME_LIMIT_SETTINGS: 'EDIT_PLAYER_GAME_TIME_LIMIT_SETTINGS',

  GET_PLAYER_LEGACY_DATA: 'GET_PLAYER_LEGACY_DATA',
  SAVE_PLAYER_LEGACY_DATA: 'SAVE_PLAYER_LEGACY_DATA',
  RESET_PLAYER_LEGACY_DATA: 'RESET_PLAYER_LEGACY_DATA',

  GET_PLAYER_OTP: 'GET_PLAYER_OTP',
  SAVE_PLAYER_OTP: 'SAVE_PLAYER_OTP',
  RESET_PLAYER_OTP: 'RESET_PLAYER_OTP',

  SET_PLAYER_OTP: 'SET_PLAYER_OTP',

  CHANGE_PLAYER_BLACKLISTED_STATUS: 'CHANGE_PLAYER_BLACKLISTED_STATUS',
};

export default PlayerActionType;
